.page {
  margin-top: 36px;
}

.placeName {
  display: flex;
  align-items: center;
  margin: auto;
}
